import { Typography } from '@euler/app/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { CoachingReportCriticalErrorView } from '@euler/model/coaching-practice';
import { memo } from 'react';
import { View } from 'react-native';
import { aiColors } from '../../../../ai-suite/theme';
import { ReportSection } from './ReportSection';

/** What capped the stars: what was said, why it matters, a better line. */
export const CriticalErrors = memo(
  ({ errors }: { errors: CoachingReportCriticalErrorView[] }) => {
    const { rpx } = useResponsiveContext();
    return (
      <ReportSection title="关键失误">
        {errors.map((x, i) => (
          <View key={`${x.criticalError}-${i}`} style={{ gap: rpx(4) }}>
            <Typography.Text size={rpx(14)} bold color={aiColors.destructive}>
              {x.criticalError}
            </Typography.Text>
            {x.quote ? (
              <Typography.Text size={rpx(13)} color={aiColors.foreground}>
                {`你说：「${x.quote}」`}
              </Typography.Text>
            ) : null}
            {x.why ? (
              <Typography.Text size={rpx(13)} color={aiColors.mutedForeground}>
                {x.why}
              </Typography.Text>
            ) : null}
            {x.instead ? (
              <Typography.Text size={rpx(13)} color={aiColors.accentForeground}>
                {`可以这样说：「${x.instead}」`}
              </Typography.Text>
            ) : null}
          </View>
        ))}
      </ReportSection>
    );
  },
);
